import { useRadarLocale } from '@/i18n/RadarLocaleContext';
import { useEffect, useRef, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import {useWorkspaceJourney} from './RadarJourney';

// Keep children mounted so closing a draft never discards local edits. Native
// modal focus trapping, Escape and return focus are provided by the browser.
export function RadarDialog({open,title,onClose,children,closeLabel,drawer=false}:{open:boolean;title:string;onClose:()=>void;children:ReactNode;closeLabel?:string;drawer?:boolean}) {
 const {t}=useRadarLocale();
 const journey=useWorkspaceJourney();
 const ref=useRef<HTMLDialogElement>(null);
 useEffect(()=>{
   const dialog=ref.current;if(!dialog)return;
   if(open && !dialog.open){if(dialog.showModal)dialog.showModal();else dialog.setAttribute('open','');}
   if(!open && dialog.open){if(dialog.close)dialog.close();else dialog.removeAttribute('open');}
 },[open]);
 const dialog=<dialog ref={ref} aria-label={title} className={`radar-worklist-dialog radar-outreach-panel ${drawer?'radar-detail-dialog':''}`} onCancel={e=>{e.preventDefault();onClose();}}>
   <header><h2>{title}</h2><button type="button" className="radar-secondary-action" onClick={onClose} aria-label={closeLabel||(title==='Prepare emails'?'Close preparation':'Close draft')}>{journey?t("Close"):"Close"}</button></header>
   <div className="radar-worklist-dialog-body">{children}</div>
 </dialog>;
 return createPortal(journey?<div className="radar-journey-enabled">{dialog}</div>:dialog,document.body);
}
